import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index22() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="container">
    <div className="row">
      <div className="col-lg-8 col-12">
        <div className="intro-slider-container mt-2">
          <div className="intro-slider owl-carousel owl-theme owl-nav-inside owl-light" data-toggle="owl" data-owl-options="{
                              &quot;dots&quot;: true,
                              &quot;nav&quot;: true, 
                              &quot;responsive&quot;: {
                                  &quot;1200&quot;: {
                                      &quot;nav&quot;: true,
                                      &quot;dots&quot;: true
                                  }
                              }
                          }">
            <div className="intro-slide banner-lg" style={{backgroundImage: 'url(asset/images/demos/demo-22/slider/slide-1.jpg)'}}>
              <div className="intro">
                <div className="title">
                  <a>deal of the day</a>
                </div>
                <div className="content">
                  <h3><span>up to</span> 20% <span>off</span></h3><h4>heavy duty deals</h4>
                </div>
                <div className="action">
                  <a href="category.html">discover now</a>
                </div>
              </div>
            </div>{/* End .intro-slide */}
            <div className="intro-slide banner-lg" style={{backgroundImage: 'url(asset/images/demos/demo-22/slider/slide-2.jpg)'}}>
              <div className="intro">
                <div className="title">
                  <a>clearance</a>
                </div>
                <div className="content">
                  <h3>power tools<br />up to <span>30% off</span></h3>
                </div>
                <div className="action">
                  <a href="category.html">discover now</a>
                </div>
              </div>
            </div>{/* End .intro-slide */}
          </div>{/* End .intro-slider owl-carousel owl-simple */}
          <span className="slider-loader" />{/* End .slider-loader */}
        </div>{/* End .intro-slider-container */}
      </div>
      <div className="col-lg-4 banner">
        <div className="col-12" style={{backgroundImage: 'url(asset/images/demos/demo-22/slider/banner-1.jpg)'}}>
          <div className="intro">
            <div className="title">
              <h3>New arrivals</h3>
            </div>
            <div className="content">
              <h3>up to </h3> <h3 className="highlight">&nbsp;40% off</h3>
            </div>
            <div className="action">
              <a href="category.html">shop now</a>
            </div>
          </div>
        </div>
        <div className="col-12" style={{backgroundImage: 'url(asset/images/demos/demo-22/slider/banner-2.jpg)'}}>
          <div className="intro">
            <div className="title">
              <h2>outdoor</h2>
            </div>
            <div className="content">
              <h4>power equipment</h4>
            </div>
            <div className="action">
              <a href="category.html">shop now</a>
            </div>
          </div>
        </div>
        <div className="col-12" style={{backgroundImage: 'url(asset/images/demos/demo-22/slider/banner-3.jpg)'}}>
          <div className="intro">
            <div className="title">
              <h3 className="highlight">save 20%</h3><h3>&nbsp;or more</h3>
            </div>
            <div className="content">
              <h3>deals &amp; savings</h3>
            </div>
            <div className="action">
              <a href="category.html">shop now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container text-center shop">
    <h2 className="title mt-4 mb-5"> Shop by Brands </h2>
    <div className="owl-carousel mb-5 owl-simple" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: true, 
                  &quot;dots&quot;: false,
                  &quot;margin&quot;: 30,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;420&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;600&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;900&quot;: {
                          &quot;items&quot;:5
                      },
                      &quot;1024&quot;: {
                          &quot;items&quot;:6
                      }
                  }
              }">
      <a href="#" className="brand">
        <img src="asset/images/brands/1.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/2.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/3.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/4.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/5.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/6.png" alt="Brand Name" />
      </a>
      <a href="#" className="brand">
        <img src="asset/images/brands/7.png" alt="Brand Name" />
      </a>
    </div>{/* End .owl-carousel */}
  </div>{/* End .container */}
  <div className="featured-back" style={{backgroundImage: 'url(asset/images/demos/demo-22/featured/background.jpg)'}}>
    <div className="container">
      <div className="section-title">
        <ul className="nav nav-pills nav-border-anim" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="tab-featured-link" data-toggle="tab" href="#tab-featured" role="tab" aria-controls="tab-featured" aria-selected="true"><span>Featured</span></a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="tab-best-link" data-toggle="tab" href="#tab-best" role="tab" aria-controls="tab-best" aria-selected="false"><span>Bestsellers</span></a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="tab-sale-link" data-toggle="tab" href="#tab-sale" role="tab" aria-controls="tab-sale" aria-selected="false"><span>Sale</span></a>
          </li>
        </ul>
        <a className="link" href="#">All Featured Products</a>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-4">
          <div className="product-lg">
            <figure className="product-media">
              <span className="product-label label-limited">limited time sale</span>
              <a href="product.html">
                <img src="asset/images/demos/demo-22/featured/product-1.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="save-price"><span>Save $64.00</span></h3>
              <h3 className="product-title"><a href="product.html">DEWALT DWE575SB</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$79.00</span>
                <span className="old-price">Was $143.00</span>
              </div>{/* End .product-price */}
              <div className="action">
                <a href="category.html">shop now</a>
              </div>
            </div>{/* End .product-body */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
        </div>
        <div className="col-lg-8 col-md-8">
          <div className="tab-content">
            <div className="tab-pane fade show active" id="tab-featured" role="tabpanel" aria-labelledby="tab-featured-link">
              <div className="row products all">
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <span className="product-label label-sale">Sale</span>
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-2.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Woodworking</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT DWARA 100</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">$23.35</span>
                        <span className="old-price">Was $40.99</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-3.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tool Accessories</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Milwaukee Battery 18V LITHIUM</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $34.99
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-4.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT Hammer Drill</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $79.00
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-5.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Air Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Makita XBU02PT1</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $302.20
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <span className="product-label label-sale">Sale</span>
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-6.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Hand Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT DWASHRIR</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">$70.95</span>
                        <span className="old-price">Was $90.00</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-7.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Milwaukee 2648-20</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $151.75
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-nav product-nav-dots">
                        <a href="#" className="active" style={{background: '#af5f23'}}><span className="sr-only">Color name</span></a>
                        <a href="#" style={{background: '#806f55'}}><span className="sr-only">Color name</span></a>
                        <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                      </div>{/* End .product-nav */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
              </div>{/* End .row */}
            </div>{/* .End .tab-pane */}
            <div className="tab-pane fade" id="tab-best" role="tabpanel" aria-labelledby="tab-best-link">
              <div className="row products">
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <span className="product-label label-sale">Sale</span>
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-2.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Woodworking</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT DWARA 100</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">$23.35</span>
                        <span className="old-price">Was $40.99</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-4.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT Hammer Drill</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $79.00
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-5.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Air Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Makita XBU02PT1</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $302.20
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
              </div>
            </div>
            <div className="tab-pane fade" id="tab-sale" role="tabpanel" aria-labelledby="tab-sale-link">
              <div className="row products">
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-4.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT Hammer Drill</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $79.00
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-5.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Air Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Makita XBU02PT1</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $302.20
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <span className="product-label label-sale">Sale</span>
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-6.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Hand Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">DEWALT DWASHRIR</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">$70.95</span>
                        <span className="old-price">Was $90.00</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
                <div className="col-lg-4 col-6">
                  <div className="product product-3 text-center">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-22/featured/product-7.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                      </div>{/* End .product-action-vertical */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <div className="product-cat">
                        <a href="#">Power Tools</a>
                      </div>{/* End .product-cat */}
                      <h3 className="product-title"><a href="product.html">Milwaukee 2648-20</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $151.75
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                    <div className="product-footer">
                      <div className="ratings-container">
                        <div className="ratings">
                          <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                        </div>{/* End .ratings */}
                        <span className="ratings-text">( 4 Reviews )</span>
                      </div>{/* End .rating-container */}
                      <div className="product-nav product-nav-dots">
                        <a href="#" className="active" style={{background: '#af5f23'}}><span className="sr-only">Color name</span></a>
                        <a href="#" style={{background: '#806f55'}}><span className="sr-only">Color name</span></a>
                        <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                      </div>{/* End .product-nav */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart" title="Add to cart"><span>add to cart</span></a>
                        <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
                      </div>{/* End .product-action */}
                    </div>{/* End .product-footer */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2" />{/* End .mb-6 */}
    </div>{/* End .container */}
  </div>
  <div className="newsletter" style={{backgroundImage: 'url(asset/images/demos/demo-22/newsLetter/background.jpg)'}}>
    <div className="container">
      <div className="subscribe text-center">
        <div className="intro">
          <h3 className="title">Subscribe for Our Newsletter</h3>
          <h4 className="content">Learn about new offers and get more deals by joining our newsletter</h4>
        </div>
        <div className="subscribe action">
          <form action="#">
            <div className="input-group">
              <input type="email" placeholder="Enter your Email Address" aria-label="Email Adress" required />
              <div className="input-group-append">
                <button className="btn btn-subscribe" type="submit"><span>Subscribe now</span></button>
              </div>{/* .End .input-group-append */}
            </div>{/* .End .input-group */}
          </form>
        </div>
      </div>
    </div>
  </div>
  <div className="container banner-container">
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-6 banner-lg">
        <a href="category.html">
          <img src="asset/images/demos/demo-22/banner/banner-1.jpg" />
        </a>
        <div className="banner-content">
          <div className="title">
            <a href="category.html">save up to 30%</a>
          </div>
          <div className="content">
            <a href="category.html">
              <h3 className="highlight">Premium Brands</h3>
              <h4>for the Toughest Jobs</h4>
            </a>
          </div>
          <div className="action">
            <a href="category.html">discover now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 banner-lg">
        <a href="category.html">
          <img src="asset/images/demos/demo-22/banner/banner-2.jpg" />
        </a>
        <div className="banner-content">
          <div className="title">
            <a href="category.html">best sellers in tools</a>
          </div>
          <div className="content">
            <a href="category.html">
              <h3>Pro-level tools</h3>
              <h4 className="highlight">Save on Bestsellers</h4>
            </a>
          </div>
          <div className="action">
            <a href="category.html">shop now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container service">
    <div className="row">
      <div className="col-sm-6 col-lg-3">
        <div className="icon-box icon-box-side">
          <span className="icon-box-icon text-dark">
            <i className="icon-rocket" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Free Shipping</h3>{/* End .icon-box-title */}
            <p>Orders $50 or more</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-sm-6 col-lg-4 */}
      <div className="col-sm-6 col-lg-3">
        <div className="icon-box icon-box-side">
          <span className="icon-box-icon text-dark">
            <i className="icon-rotate-left" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Free Returns</h3>{/* End .icon-box-title */}
            <p>Within 30 days</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-sm-6 col-lg-4 */}
      <div className="col-sm-6 col-lg-3">
        <div className="icon-box icon-box-side">
          <span className="icon-box-icon text-dark">
            <i className="icon-info-circle" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Get 20% Off 1 Item</h3>{/* End .icon-box-title */}
            <p>When you sign up</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-sm-6 col-lg-4 */}
      <div className="col-sm-6 col-lg-3">
        <div className="icon-box icon-box-side">
          <span className="icon-box-icon text-dark">
            <i className="icon-life-ring" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">We Support</h3>{/* End .icon-box-title */}
            <p>24/7 amazing services</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-sm-6 col-lg-4 */}
    </div>
  </div>
  <div className="container popular">
    <hr className="mb-5" />
    <div className="section-title">
      <div><p className="title"><span>Popular Products</span></p></div>
      <a className="link" href="#">See All Products</a>
    </div>
    <div className="row products">
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <span className="product-label label-sale">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-1.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Air Tools &amp; Compressors</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Makita XCV11Z</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$158.40</span>
              <span className="old-price">Was $330.00</span>
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 4 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#af5f23'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#806f55'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <span className="product-label label-sale">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-2.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Milwaukee 2803-20</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$77.99</span>
              <span className="old-price">Was $115.00</span>
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 2 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-3.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Makita XSH03Z</a></h3>{/* End .product-title */}
            <div className="product-price">
              $119.99
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 2 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#cc6666'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#ccccff'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <span className="product-label label-sale">Sale</span>
            <span className="product-label label-new">New</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-4.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Air Tools &amp; Compressors</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">DEWALT DCE511B</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$100.99</span>
              <span className="old-price">Was $130.00</span>
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '0%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 0 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#ffca51'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#bb8379'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#666666'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-5.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Hand Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">TEKTON 30603 Fiberglass</a></h3>{/* End .product-title */}
            <div className="product-price">
              $8.99
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 4 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-6.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tool Accessories</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">DEWALT DCB205 20V</a></h3>{/* End .product-title */}
            <div className="product-price">
              $69.94
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 4 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <span className="product-label label-sale">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-7.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">BLACK+DECKER BDEJS600C</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$42.99</span>
              <span className="old-price">Was $67.50</span>
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 3 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#78645f'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#b89474'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#666666'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-8.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tool Accessories</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">DEWALT DW1354 14-Piece Titanium Drill Bit Set</a></h3>{/* End .product-title */}
            <div className="product-price">
              $29.99
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '0%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 0 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-9.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">WEN 6530</a></h3>{/* End .product-title */}
            <div className="product-price">
              $41.61
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 7 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
      <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
        <div className="product product-3 text-center">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-22/products/product-10.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action-vertical */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <div className="product-cat">
              <a href="#">Power Tools</a>
            </div>{/* End .product-cat */}
            <h3 className="product-title"><a href="product.html">Ryobi P506 One+</a></h3>{/* End .product-title */}
            <div className="product-price">
              $35.85
            </div>{/* End .product-price */}
          </div>{/* End .product-body */}
          <div className="product-footer">
            <div className="ratings-container">
              <div className="ratings">
                <div className="ratings-val" style={{width: '0%'}} />{/* End .ratings-val */}
              </div>{/* End .ratings */}
              <span className="ratings-text">( 0 Reviews )</span>
            </div>{/* End .rating-container */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart" title="Add to cart" />
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view" />
            </div>{/* End .product-action */}
          </div>{/* End .product-footer */}
        </div>{/* End .product */}
      </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
    </div>{/* End .row */}
  </div>
  <div className="container bannerad">
    <div className="banner-lg" style={{backgroundImage: 'url(asset/images/demos/demo-22/bannerad/background.jpg)'}}>
      <div className="price">
        <h4 className="highlight">from</h4><h3>$39</h3><sup className="highlight">,99</sup>
      </div>
      <div className="content">
        <h4>woodworking tools</h4>
        <h3>from top rated brands</h3>
        <div className="action">
          <a href="category.html">discover now</a>
        </div>
      </div>
    </div>
  </div>
  <div className="container post">
    <div className="section-title">
      <div><p className="title"><span>Our Blog Posts</span></p></div>
      <a className="link" href="#">See All Posts</a>
    </div>
    <div className="owl-carousel owl-simple mb-4" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: true, 
                  &quot;dots&quot;: false,
                  &quot;items&quot;: 3,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:1,
                          &quot;dots&quot;:true
                      },
                      &quot;520&quot;: {
                          &quot;items&quot;:2,
                          &quot;dots&quot;:true
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      }
                  }
              }">
      <article className="entry">
        <figure className="entry-media">
          <a href="single.html">
            <img src="asset/images/demos/demo-22/post/post-1.jpg" alt="image desc" />
          </a>
        </figure>{/* End .entry-media */}
        <div className="entry-body text-center">
          <div className="entry-meta">
            <a href="#">Nov 22, 2018</a>, 0 Comments
          </div>{/* End .entry-meta */}
          <h3 className="entry-title">
            <a href="single.html">Sed adipiscing ornare.</a>
          </h3>{/* End .entry-title */}
          <div className="entry-content">
            <a href="single.html" className="read-more">Continue Reading</a>
          </div>{/* End .entry-content */}
        </div>{/* End .entry-body */}
      </article>{/* End .entry */}
      <article className="entry">
        <figure className="entry-media">
          <a href="single.html">
            <img src="asset/images/demos/demo-22/post/post-2.jpg" alt="image desc" />
          </a>
        </figure>{/* End .entry-media */}
        <div className="entry-body text-center">
          <div className="entry-meta">
            <a href="#">Nov 22, 2018</a>, 0 Comments
          </div>{/* End .entry-meta */}
          <h3 className="entry-title">
            <a href="single.html">Aenean dignissim pellentesque.</a>
          </h3>{/* End .entry-title */}
          <div className="entry-content">
            <a href="single.html" className="read-more">Continue Reading</a>
          </div>{/* End .entry-content */}
        </div>{/* End .entry-body */}
      </article>{/* End .entry */}
      <article className="entry">
        <figure className="entry-media">
          <a href="single.html">
            <img src="asset/images/demos/demo-22/post/post-3.jpg" alt="image desc" />
          </a>
        </figure>{/* End .entry-media */}
        <div className="entry-body text-center">
          <div className="entry-meta">
            <a href="#">Nov 22, 2018</a>, 2 Comments
          </div>{/* End .entry-meta */}
          <h3 className="entry-title">
            <a href="single.html">Quisque volutpat mattis.</a>
          </h3>{/* End .entry-title */}
          <div className="entry-content">
            <a href="single.html" className="read-more">Continue Reading</a>
          </div>{/* End .entry-content */}
        </div>{/* End .entry-body */}
      </article>{/* End .entry */}
      <article className="entry">
        <figure className="entry-media">
          <a href="single.html">
            <img src="asset/images/demos/demo-22/post/post-2.jpg" alt="image desc" />
          </a>
        </figure>{/* End .entry-media */}
        <div className="entry-body text-center">
          <div className="entry-meta">
            <a href="#">Nov 22, 2018</a>, 0 Comments
          </div>{/* End .entry-meta */}
          <h3 className="entry-title">
            <a href="single.html">Aenean dignissim pellentesque.</a>
          </h3>{/* End .entry-title */}
          <div className="entry-content">
            <a href="single.html" className="read-more">Continue Reading</a>
          </div>{/* End .entry-content */}
        </div>{/* End .entry-body */}
      </article>{/* End .entry */}
    </div>{/* End .owl-carousel */}
  </div>
</main>

        <UserFooter/>
    </div>
  )
}

export default Index22